import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Label = styled('span')`
    margin-left: 1px;
    margin-right: 2px;
    text-transform: none;
    font-size: 14px;
    white-space: pre;
    color: ${theme.palette.text.main};
    overflow: hidden;
    flex: 1;
    text-align: right;
`;

export const Title = styled('span')`
    margin-left: 1px;
    margin-right: 2px;
    text-transform: none;
    font-size: 18px;
    font-weight: 700;
    white-space: pre;
    color: ${theme.palette.text.main};
    overflow: hidden;
    align-items: right;
`;
